import PopupOptions from "../../popup_select_component/PopupOptions";
import LinkForPopupPropTypes from "../../LinkForPopupPropTypes";
import PropTypes from "prop-types";
import React from "react";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

const LinkForPopup = (props) => {
  return (
    <a className="inline_link" onClick={props.onClickPopupLink}>
      <input
        type="text"
        name="input_area_name"
        className="qualification_license"
        placeholder={PopupOptions.qualifications.title}
        readOnly="readonly"
        value={props.inputValue}
        onChange={props.onChangeInputValue}
      />
    </a>
  );
};

LinkForPopup.propTypes = LinkForPopupPropTypes;

export default LinkForPopup;